module.exports = __webpack_public_path__ + "static/media/mine.804e09d6.png";